import { RequestHandler } from 'express';

import { saveRecorded } from '~/app/mockingMiddleware';
import { MigrateRequest } from '~/services';

import ContensisMigrationService from '~/services/ContensisMigrationService';
import mapAppErrorToObject from '~/transformations/mapAppErrorToObject';

export const migrateEverything: RequestHandler = async (req, res, next) => {
  try {
    const {
      payload = {},
      preview,
    }: {
      payload?: MigrateRequest;
      preview?: boolean;
    } = res.locals;

    const migrationService = new ContensisMigrationService(payload, preview);

    const results = await migrationService.MigrateEnvironment();

    const response = { committed: !preview, ...results };

    res.send(response);

    saveRecorded(req, res, {
      operation: 'migrateEverything',
      response,
    });

    res.locals.response = response;
  } catch (ex: any) {
    res.locals.response = { error: mapAppErrorToObject(ex) };
    res.status(500).send(res.locals.response);
  }
  next();
};
